/* eslint-disable react/destructuring-assignment */
import * as React from "react";

const DoubleArrowDown = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width={13} height={12} fill="none" {...props}>
    <path
      fill={props.color || "#0F172A"}
      d="M10.515 6.11a.375.375 0 0 1 0 .53l-3.75 3.75a.375.375 0 0 1-.53 0l-3.75-3.75a.375.375 0 1 1 .53-.53L6.5 9.595 9.985 6.11a.375.375 0 0 1 .53 0Zm-4.28.53a.375.375 0 0 0 .53 0l3.75-3.75a.375.375 0 1 0-.53-.53L6.5 5.845 3.016 2.36a.375.375 0 1 0-.531.53l3.75 3.75Z"
    />
  </svg>
);
export default DoubleArrowDown;
